import { Link, useParams } from 'react-router-dom';
import { Breadcrumb, Button, Form, Layout, Result, Space, Spin } from 'antd';

import { Hooks, PageLayout } from '@app/web-components';

import { NotFoundPage } from '../../../../../common';
import { useEditProcess, useGetProcess } from '../data';
import { RoleLabelRenderer } from '../libs/use-ags-role-picker';
import { ProcessManagementFormData, useProcessForm } from '../libs/use-process-form';

export const EditPage = () => {
  const { id } = useParams();

  const {
    data,
    isError,
    isPending: processLoading,
  } = useGetProcess(Number(id), { enabled: !!(Number(id) | 0), staleTime: Infinity });
  const edit = useEditProcess(id);
  const { getFormProps, getGotoProcessesButtonProps, getSuccessResultProps } = useProcessForm(edit);
  const layoutContentProps = Hooks.useFormLayout();

  if (processLoading) {
    return <Spin style={{ width: '100%' }} />;
  }

  if (isError || !data) {
    return (
      <NotFoundPage subTitle="Sorry, this process does not exist or was deleted.">
        <Button {...getGotoProcessesButtonProps()} />
      </NotFoundPage>
    );
  }

  const initialValues: ProcessManagementFormData = {
    name: data.name,
    t3NodeId: data.t3NodeId,
    pdmPrefixes: data.pdmPrefixes,
    agsRoles: data.agsRoleToDmsProcessMap.map((x) => ({
      id: x.id,
      access: {
        label: <RoleLabelRenderer employeeType={x.access.employeeType}>{x.access.name}</RoleLabelRenderer>,
        value: x.access.externalId,
      },
      employeeType: x.employeeType,
    })),
  };

  return (
    <Space direction="vertical" style={{ overflow: 'auto' }}>
      <Breadcrumb
        style={{ margin: '16px 0' }}
        items={[
          { title: <Link to="/">Home</Link> },
          { title: 'Admin' },
          { title: <Link to="../">Processes</Link> },
          { title: 'Edit' },
        ]}
      />

      <Layout.Content {...layoutContentProps}>
        <PageLayout.Title title={`Edit Process`} />
        {edit.isSuccess ? (
          <Result {...getSuccessResultProps()} title="Successfully edited a process!" />
        ) : (
          <Form {...getFormProps()} initialValues={initialValues} />
        )}
      </Layout.Content>
    </Space>
  );
};
